import { FC } from 'react';
import PropTypes from 'prop-types';
import Scrollbars from 'react-custom-scrollbars-2';
import { Box } from '@mui/material';
import { ScrollbarProps } from 'src/models/Scollbar.interface';

const ReactNodePropType = (
  props: any,
  propName: string,
  componentName: string
) => {
  const prop = props[propName];
  if (
    prop &&
    !(
      prop instanceof Array ||
      prop instanceof Object ||
      typeof prop === 'string' ||
      typeof prop === 'number' ||
      typeof prop === 'function'
    )
  ) {
    return new Error(
      `${componentName}: Invalid prop \`${propName}\` of type \`${typeof prop}\` supplied to \`${componentName}\`, expected a ReactNode.`
    );
  }
  return null;
};

const Scrollbar: FC<ScrollbarProps> = ({
  className,
  children,
  thumbColor = 'var(--inactive-btn)',
  ...rest
}) => {
  return (
    <Scrollbars
      renderThumbVertical={() => {
        return (
          <Box
            sx={{
              width: 1,
              background: thumbColor,
              borderRadius: 20,
              transition: 'background 0.3s ease',
            }}
          />
        );
      }}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
};

Scrollbar.propTypes = {
  children: ReactNodePropType,
  className: PropTypes.string,
  thumbColor: PropTypes.string,
};

export default Scrollbar;
